const CHAVE = 'sheafyield:faixa-instalacao-ate';
const TRINTA_DIAS = 30 * 86_400_000;

export function emStandalone(): boolean {
  const nav = navigator as Navigator & { standalone?: boolean };
  return (
    (typeof matchMedia === 'function' &&
      matchMedia('(display-mode: standalone)').matches) ||
    nav.standalone === true
  );
}

export function faixaDispensada(agora: number = Date.now()): boolean {
  try {
    const ate = Number(localStorage.getItem(CHAVE));
    return Number.isFinite(ate) && ate > agora;
  } catch {
    return false;
  }
}

export function dispensarFaixa(agora: number = Date.now()): void {
  try {
    localStorage.setItem(CHAVE, String(agora + TRINTA_DIAS));
  } catch {
    // sem localStorage: a faixa volta na próxima abertura
  }
}
